<div class="modal-container">
    <div class="modal-header">
      <h5 class="modal-title">{{ userName }}'s Assigned Donors List</h5>
    </div>
  
    <div class="modal-body">
      @if (loading) {
        <div class="spinner-container">
          <div class="spinner"></div>
        </div>
      } @else if (errorMessage) {
        <div class="alert alert-danger">{{ errorMessage }}</div>
      } @else {
        @if(assignedDonors.length > 0){
            <ul class="donor-list">
                @for (donor of assignedDonors; track donor) {
                  <li class="donor-item">
                    <img [src]="donor.avatar || 'placeholder_profile.png'" class="avatar" />
                    <div class="donor-details">
                      <p class="name">{{ donor.firstName }} {{ donor.lastName }}</p>
                      <p class="email">{{ donor.email }}</p>
                    </div>
                  </li>
                }
              </ul>
        } @else {
            <p class="no-donor-text">No Donors assigned</p>
        }
       
      }
    </div>
  
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" (click)="closeModal()">Close</button>
    </div>
  </div>